export const multiReasonValidation = (updateRecords) => {
  return updateRecords.every(
    (record) => record.reason && record.reason.length > 0,
  );
};

export default multiReasonValidation;
